<template>
  <section>
    <ul class="list-none space-y-12">
      <li v-for="facetItem in visibleFacetItems" :key="facetItem.key">
        <RevCheckbox
          :id="facetItem.id"
          :checked="facetItem.value === modelValue"
          class="mb-8"
          :name
          :value="facetItem.value"
          @change="handleValueChange(facetItem.value)"
        >
          <template #label>
            <span class="line-clamp-1">
              {{
                i18n(translations.nameAndCount, {
                  name: facetItem.name,
                  count: facetItem.count,
                })
              }}</span
            >
          </template>
        </RevCheckbox>
      </li>
    </ul>
    <RevLink
      v-if="isShowAllToggleVisible"
      class="body-2-link mt-8"
      underlined
      @click="handleToggleShowAll"
    >
      {{ visibilityText }}
    </RevLink>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCheckbox } from '@ds/components/Checkbox'
import { RevLink } from '@ds/components/Link'

import { MAX_VISIBLE_FACET_COUNT } from './Facet.constants'
import translations from './Facet.translations'

const props = defineProps<{
  name: string
  facet: Record<string, string>
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue'])

const i18n = useI18n()

const shouldShowAll = ref(false)

const facetItems = computed(() =>
  Object.keys(props.facet).map((key) => ({
    name: key,
    id: `${props.name}_${key}`,
    value: key.toString(),
    key,
    count: props.facet[key],
  })),
)

const isShowAllToggleVisible = computed(
  () => facetItems.value.length > MAX_VISIBLE_FACET_COUNT,
)

const visibilityText = computed(() =>
  shouldShowAll.value
    ? i18n(translations.showLess)
    : i18n(translations.showMore),
)

const visibleFacetItems = computed(() => {
  const numberOfFacetItems = shouldShowAll.value
    ? facetItems.value.length
    : MAX_VISIBLE_FACET_COUNT

  return facetItems.value.slice(0, numberOfFacetItems)
})

function handleToggleShowAll() {
  shouldShowAll.value = !shouldShowAll.value
}

function handleValueChange(value: string) {
  const isChecked = value === props.modelValue
  emit('update:modelValue', {
    name: props.name,
    value: isChecked ? null : value,
  })
}
</script>
